const DEFAULT_PAGINATION_LIMIT = 50;
export { DEFAULT_PAGINATION_LIMIT };
